import { html } from 'lit';

export const emTemplate = (
  node: HTMLElement,
) => html`<one-text strong>${node.innerHTML}</one-text>`;

export default emTemplate;
